import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { teceoLightGrayTooltipBackground } from '../../../Theme';

export const useSharedEntitiesStyles = makeStyles()((theme: Theme) => ({
  optionTag: { maxWidth: '200px' },
  autocomplete: {
    '& .MuiAutocomplete-fullWidth': {
      borderRadius: theme.spacing(4),
    },
    '& .MuiAutocomplete-inputRoot': {
      borderRadius: theme.spacing(4),
      height: 40,
      backgroundColor: teceoLightGrayTooltipBackground,
    },
    '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
      borderColor: teceoLightGrayTooltipBackground,
    },
  },
  select: {
    '& .MuiSelect-select': {
      borderRadius: `${theme.spacing(4)} !important`,
      backgroundColor: teceoLightGrayTooltipBackground,
      borderColor: teceoLightGrayTooltipBackground,
      paddingLeft: theme.spacing(2),
    },
    width: '100%',
    height: '40px',
  },
  selectInputRoot: {
    borderRadius: theme.spacing(4),
    height: '40px',
    backgroundColor: teceoLightGrayTooltipBackground,
    '& .MuiOutlinedInput-notchedOutline': {
      paddingLeft: theme.spacing(2),
      borderColor: teceoLightGrayTooltipBackground,
    },
  },
  bottomDivider: {
    borderTop: '1px solid rgba(0,0,0, 0.16)',
    paddingBottom: '24px',
  },
  root: {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
  },
  footerSpacing: {
    paddingBottom: '24px',
    paddingRight: '24px',
  },
  fileCopyIcon: {
    fontSize: '15px !important',
  },
  configAccessSpacing: {
    paddingBottom: theme.spacing(1),
    paddingTop: theme.spacing(1),
  },
  configAccessLabel: {
    paddingLeft: theme.spacing(1),
    paddingTop: theme.spacing(3),
  },
  shareInfoSpacing: {
    paddingLeft: theme.spacing(1),
  },
  shareBySpacing: {
    paddingLeft: theme.spacing(1),
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(1),
  },
  shareButtonContainer: {
    paddingBottom: theme.spacing(1),
  },
  shareEmailAutocompleteSpacing: {
    paddingBottom: theme.spacing(5),
  },
  shareButton: {
    width: '160px',
    height: '35px',
    borderRadius: '38px',
    padding: '6px 16px 6px 16px',
  },
  cancelLinksSpacing: {
    paddingLeft: theme.spacing(4),
    cursor: 'pointer',
  },
}));
